var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasSlotContent)?_c('SfBadge',{staticClass:"vaimo-badge",class:Object.assign({}, _vm.variantsClasses,
    {'bg-blanc': _vm.white}),attrs:{"variant":_vm.variant}},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }